import React from "react";
import { NavLink } from "react-router-dom";
import { Coins, Vault } from "lucide-react";

/**
 * Vaults / My Deposits.
 *
 * The same object as the app header's nav: a sunken pill rail holding one
 * raised item (`.ce-nav-rail` + `.ce-nav-item`, neumorph2026.css §11). It was
 * a full-width white card with a `bg-purple-100` fill under the active link —
 * a tinted rectangle where every other switch in the app is a raised thumb.
 *
 * The rail sizes to its two items rather than spanning the page: it is a
 * two-value choice, and a card the width of the viewport implied it was a
 * section header.
 */
const NAV = [
  { name: "Vaults", path: "/perps/vaults", Icon: Vault },
  { name: "My Deposits", path: "/perps/deposits", Icon: Coins },
];

const VaultsTopBar = () => (
  <div className="w-full mb-4">
    <div className="ce-nav-rail inline-flex" style={{ fontFamily: "General Sans" }}>
      {NAV.map(({ name, path, Icon }) => (
        <NavLink
          key={path}
          to={path}
          className={({ isActive }) =>
            `ce-nav-item${isActive ? " ce-nav-item-on" : ""}`
          }
          style={{ width: "auto", minWidth: 122 }}
        >
          <Icon className="ce-nav-icon w-[15px] h-[15px]" />
          <span className="ce-nav-label">{name}</span>
        </NavLink>
      ))}
    </div>
  </div>
);

export default VaultsTopBar;
